export const DRAWING_WIDTH = 360;
export const DRAWING_HEIGHT = 480;
export const DRAWING_LIMITS = { strokes: 1000, points: 50000 };
export const DRAWING_SURFACE = '#FAF9F6';
export const DRAWING_COLORS = ['#000000', DRAWING_SURFACE, '#E63535', '#FF927B', '#FFDFAC', '#0AA555', '#2369E8', '#914CE8', '#808080'];
export const FULL_CROP = { top: 0, bottom: DRAWING_HEIGHT };
export const MIN_CROP_HEIGHT = 80;
export const validCrop = crop => crop && Number.isFinite(crop.top) && Number.isFinite(crop.bottom)
  && crop.top >= 0 && crop.bottom <= DRAWING_HEIGHT && crop.bottom - crop.top >= MIN_CROP_HEIGHT;

export function moveCrop(crop, edge, position) {
  if (!Number.isFinite(position)) return crop;
  const value = Math.round(position);
  return edge === 'top'
    ? { ...crop, top: Math.max(0, Math.min(value, crop.bottom - MIN_CROP_HEIGHT)) }
    : { ...crop, bottom: Math.min(DRAWING_HEIGHT, Math.max(value, crop.top + MIN_CROP_HEIGHT)) };
}

export const validDrawingId = id => typeof id === 'string' && /^[a-zA-Z0-9_-]{1,80}$/.test(id);

// Keep persisted paths bounded and purely numeric/colour data. In particular,
// imported SVG, URLs and arbitrary attributes never become a drawing draft.
export function validPaths(paths) {
  if (!Array.isArray(paths) || paths.length > DRAWING_LIMITS.strokes) return false;
  let points = 0;
  return paths.every(path => {
    if (!path || typeof path.drawMode !== 'boolean' || !Number.isFinite(path.strokeWidth)
      || path.strokeWidth < 1 || path.strokeWidth > 64 || !Array.isArray(path.paths)
      || typeof path.strokeColor !== 'string' || path.strokeColor.length > 64
      || !/^(#[0-9a-f]{3,8}|rgba?\([\d.,\s]+\)|black|white)$/i.test(path.strokeColor)) return false;
    points += path.paths.length;
    return points <= DRAWING_LIMITS.points && path.paths.every(p => Number.isFinite(p.x) && Number.isFinite(p.y)
      && Math.abs(p.x) <= DRAWING_WIDTH * 4 && Math.abs(p.y) <= DRAWING_HEIGHT * 4);
  });
}

export function brushColor(color, tool) {
  if (tool !== 'marker') return color;
  const hex = color.slice(1);
  return `rgba(${[0, 2, 4].map(i => parseInt(hex.slice(i, i + 2), 16)).join(',')},0.35)`;
}

// Local editing metadata is never sent to the API or shown in a repost.
export function serializeDrawingHTML(html) {
  if (!html.includes('data-wiw-drawing')) return html;
  const dom = document.createElement('div');
  dom.innerHTML = html;
  dom.querySelectorAll('[data-wiw-drawing]').forEach(node => node.removeAttribute('data-wiw-drawing'));
  return dom.innerHTML;
}
